import React from 'react';
const AdTag = ({ isAd = false }) =>
  isAd && <div className="ad-tag" data-l10n-id="ad" />;

export default AdTag;
